import { render, staticRenderFns } from "./jurnalumum.vue?vue&type=template&id=c0c40a9e&scoped=true"
import script from "./jurnalumum.vue?vue&type=script&lang=js"
export * from "./jurnalumum.vue?vue&type=script&lang=js"
import style0 from "./jurnalumum.vue?vue&type=style&index=0&id=c0c40a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c40a9e",
  null
  
)

export default component.exports